import React, { useState } from 'react';
import './LoginMenu.scss';

export const LoginMenu = ({ scheduleItems, className, onClose }) => {
  const [click, setClick] = useState(false);

  const handleClick = () => {
    setClick(!click);
    onClose();
  };

  return (
    <ul
      className={`z-10 ${
        click ? 'navbar__login-menu clicked' : 'navbar__login-menu'
      } ${className || ''}`}
    >
      {scheduleItems.map((item, index) => (
        <LoginElement
          key={`mobile-login-${index}`}
          id={index}
          {...item}
          onClick={handleClick}
        />
      ))}
    </ul>
  );
};

const LoginElement = ({ id, label, url, cName, onClick }) => {
  return (
    <li key={id} className="login__element">
      <a
        className={`flex h-full w-full items-center ${cName}`}
        href={url}
        onClick={onClick}
      >
        {label}
      </a>
    </li>
  );
};
